import { Card, CardBody, Input } from '@heroui/react';
import React from 'react';
import { FiSearch } from 'react-icons/fi';

export interface TableHeaderProps {
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  searchPlaceholder?: string;
  isLoading?: boolean;
  children?: React.ReactNode;
  className?: string;
  /** Extra classes for the search wrapper, e.g. to cap its width. */
  searchClassName?: string;
  /** Rendered hard against the right edge, away from the search and filters. */
  trailing?: React.ReactNode;
}

export const TableHeader: React.FC<TableHeaderProps> = ({
  searchValue = '',
  onSearchChange,
  searchPlaceholder = 'Search...',
  children,
  className = '',
  searchClassName = '',
  trailing,
}) => {
  return (
    <Card className={`mb-6 ${className}`}>
      <CardBody>
        <div className="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center">
          {onSearchChange && (
            <div className={`flex-1 min-w-0 ${searchClassName}`}>
              <Input
                type="text"
                placeholder={searchPlaceholder}
                value={searchValue}
                onChange={(e) => onSearchChange(e.target.value)}
                startContent={<FiSearch className="text-default-400" />}
                variant="bordered"
                size="sm"
                aria-label="Search"
                classNames={{
                  input: 'text-foreground bg-transparent px-3 py-2 text-sm',
                  inputWrapper:
                    'bg-default-100 border-default-300 hover:border-default-400 focus-within:border-primary h-10 shadow-sm hover:shadow-md transition-all duration-200',
                }}
              />
            </div>
          )}
          {children && (
            <div className="flex gap-2 items-center">{children}</div>
          )}
          {trailing && (
            <div className="flex gap-2 items-center sm:ml-auto">{trailing}</div>
          )}
        </div>
      </CardBody>
    </Card>
  );
};
